import { Platform } from 'react-native'

export default {
  TriumphPayGetInvoices: ({ UploadedDateFrom, UploadedDateTo, LastModifiedDateFrom, InvoiceStatusID }) =>
    '/carrier/payments/invoices?' +
    `${UploadedDateFrom ? '&UploadedDateFrom=' + UploadedDateFrom : ''}` +
    `${UploadedDateTo ? '&UploadedDateTo=' + UploadedDateTo : ''}` +
    `${LastModifiedDateFrom ? '&LastModifiedDateFrom=' + LastModifiedDateFrom : ''}` +
    `${InvoiceStatusID ? '&InvoiceStatusID=' + InvoiceStatusID : ''}`,
  TriumphPayGetPayments: ({ UploadedDateFrom, UploadedDateTo, LastModifiedDateFrom, InvoiceStatusID }) =>
    '/carrier/payments/invoices?InvoiceStatusID=3' +
    `${UploadedDateFrom ? '&UploadedDateFrom=' + UploadedDateFrom : ''}` +
    `${UploadedDateTo ? '&UploadedDateTo=' + UploadedDateTo : ''}` +
    `${LastModifiedDateFrom ? '&LastModifiedDateFrom=' + LastModifiedDateFrom : ''}` +
    `${InvoiceStatusID ? '&InvoiceStatusID=' + InvoiceStatusID : ''}`,
  TriumphPayoutTermsTypes: '/carrier/payments/payout_terms',

  TriumphPayUrl: `/carrier/payments/url?mobile=${Platform.OS !== 'web'}`,
  TriumphPayToken: (code) => `/carrier/payments/token?code=${code}`
}
